<!--  -->
<template>
  <div class="banner-box">
    <div class="head-wrapper">
      <div class="logo-wrapper">
        <img src="../../assets/images/logo.png" alt="logo" />
      </div>
      <div class="nav-wrapper">
        <span
          @click="toArrow(item.tag, item.id)"
          v-for="(item, index) in navInfo"
          :class="[item.tag === activeTag ? 'active' : '']"
          :key="item.id"
          >{{ item.title }}</span
        >
        <span  :class="[activeTag === 'login' ? 'active' : '']" @click="toLogin" v-if="!hasLoginCache">注册/登录</span>
        <span  :class="[activeTag === 'login' ? 'active' : '']" @click="toCenter" v-else>个人中心</span>
      </div>
    </div>
    <div class="slide-banner" v-if="type == 'swiper'">
      <swiper :listInfo="listInfo" :has-btn="false"></swiper>
    </div>
    <div class="slide-banner" v-if="type == 'poster'">
      <img class="poster" :src="poster" />
    </div>
    <!--登录弹窗-->
    <div v-if="isShowLogin">
      <Login @closeLogin="closeLogin" @loginResult="loginResult"></Login>
    </div>
  </div>
</template>

<script>
import Swiper from "../swiper/swiper.vue";
import Login from "../login/index.vue";
import "jquery";
export default {
  data() {
    return {
      // navInfo: [],
      navInfo: [
        {
          tag: 0,
          title: "首页",
          id: "#index"
        },
        // {
        //   tag: 1,
        //   title: "产品介绍",
        //   id: "#intelligent-wearable"
        // },
        {
          tag: 4,
          title: "行业资讯",
          id: "#announce-box"
        },
        {
          tag: 2,
          title: "关于我们",
          id: "#about-us"
        },
        // {
        //   tag: 3,
        //   title: "商户入驻",
        //   id: "#merchant-entry"
        // }
      ],
      activeTag: 0,
      logoImg: "../../assets/images/logo.png",
      isShowLogin:false,
      hasLoginCache:false,
    };
  },

  props: ["type", "listInfo", "poster", "currentTag"],

  watch: {
    // '$store.state.globalVar.hasLoginCache': { 
    //   handler: function (newVal, oldVal) { 
    //     this.hasLoginCache=newVal;
    //   }
    // },
  },

  components: {
    swiper: Swiper,
    Login: Login
  },

  computed: {},

  created() {
    this.activeTag = this.currentTag;
    if (this.$route.name == "Index") {
      const tag = this.$route.params.tag;
      const id = this.$route.params.id;
      if (tag && id) {
        this.activeTag = tag;
        const that = this;
        setTimeout(() => {
          this.activeTag = 0;
          that.toArrow(tag, id);
        }, 500);
      }
    }
    let hasLoginCache=localStorage.getItem('hasLoginCache');
    this.hasLoginCache=hasLoginCache?(hasLoginCache==1?true:false):false;//1是已经登陆未退出状态
    //this.$store.dispatch('globalVar/changeLogin', this.hasLoginCache)
  },

  mounted() {
    console.log('mounted')
    let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
    userInfo = JSON.parse(userInfo)
    if (userInfo.email) {
      this.hasLoginCache = true
    }else{
      this.hasLoginCache = false
    }
  },
  activated(){
    console.log('activated')
    let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
    userInfo = JSON.parse(userInfo)
    if (userInfo.email) {
      this.hasLoginCache = true
    }else{
      this.hasLoginCache = false
    }
  },

  methods: {
    toArrow: async function(tag, id) {
      if( tag == 3 ) {
        if(this.$route.name == "merchantEntry") return false;
        this.$router.push({ name: "merchantEntry"});
        return false
      }
      if (this.$route.name != "Index") {
        this.$router.push({ name: "Index", params: { tag: tag, id: id } });
        await this.sleep(200)
        if (tag != 0) {
          this.activeTag = tag;
          var blog = $(id).offset().top;
          const that = this;
          setTimeout(() => {
            that.activeTag = 0;
          }, 500);
          $("html,body").animate({ scrollTop: blog }, 500);
        } else {
          this.activeTag = 0;
        } 
      } else {
        if (tag != 0) {
          this.activeTag = tag;
          var blog = $(id).offset().top;
          const that = this;
          setTimeout(() => {
            that.activeTag = 0;
          }, 500);
          $("html,body").animate({ scrollTop: blog }, 500);
        }  else {
          this.activeTag = 0;
        } 
      }
    },
    sleep(timeStamps) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(true)
        }, timeStamps);
      })
    },
    toLogin(){
      this.activeTag = 'login';
      this.isShowLogin=true;
    },
    loginResult(loginInfo = {}) {
      if (loginInfo && loginInfo.loginType === 'success') {
        this.hasLoginCache = true
        localStorage.setItem('userInfo', JSON.stringify(loginInfo)) 
        this.closeLogin()
      }
    },
    closeLogin(){
      this.activeTag = 0;
      this.isShowLogin=false;
    },
    toCenter(){
      this.$router.push({ name: "personCenter"});
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 46vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  .head-wrapper {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    margin-top: 43px;
    margin-left: 280px;
    .logo-wrapper {
      float: left;
      width: 173px;
      height: 35px;
      display: flex;
      margin-right: 500px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav-wrapper {
      display: flex;
      float: left;
      span {
        display: inline-block\0;
        padding: 5px 25px 7px 25px;
        margin-right: 20px;
        min-width: 110px;
        min-width: 120px\0;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }
      span:hover {
        font-weight: 900;
        font-size: 22px;
        line-height: 22px;
      }
      .active {
        background: #fff;
        background: linear-gradient(#ffffff, #f5eff0, #ffffff);
        color: #ff789e;
        border-radius: 20px;
        font-weight: 900;
        font-size: 20px;
      }
    }
  }
  .slide-banner {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    .poster {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
.login-btn{
  font-size:18px;
  padding:10px;
  background-color:#fff;
  border:none;
  color: #ff789e;
  width:100px;
  margin-left:50px;
  cursor: pointer;
}
.center-btn{
  font-size:18px;
  padding:10px;
  background-color:#ff789e;
  border:none;
  color:#fff;
  width:100px;
  margin-left:50px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/banner/banner.vue